import React from "react";

function MapAddress() {
  return (
    <section className="w-full px-4 sm:px-6 lg:px-12 py-12">
      <h2 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-center">
        VISIT OUR <span className="text-secondary">LOCATION</span>
      </h2>
      <div className="w-24 h-1 bg-secondary mx-auto mt-4 mb-10 rounded-full"></div>
      <div
        className="
          w-full max-w-7xl mx-auto
          overflow-hidden
          rounded-2xl
          shadow-xl
          transition-all
          duration-700
          ease-in-out
          hover:scale-[1.02]
          hover:shadow-blue-500/30
          animate-fadeInUp
        "
      >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3517.6501379335277!2d78.73473987541838!3d28.841929274541084!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x222daabc5e25e99b%3A0xc5283ec1442646cf!2sDigital%20Canto!5e1!3m2!1sen!2sin!4v1769075274422!5m2!1sen!2sin"
          className="
            w-full
            h-[300px]
            sm:h-[400px]
            md:h-[500px]
            lg:h-[600px]
            border-0
          "
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          title="Digital Canto Location"
        />
      </div>
    </section>
  );
}

export default MapAddress;
